<template>
  <v-form v-model="isFormValid" ref="form">
    <v-container class="pa-0">
      <v-row dense>
        <v-col cols="12" md="6">
          <v-autocomplete
            :append-icon="'$dropdown'"
            v-model="form.country_code"
            :items="countries"
            :search-input.sync="countrySearch"
            item-text="name"
            item-value="code"
            dense
            outlined
            :label="$t('profile.country')"
            @change="countrySearch=''"
            small
            :rules="requiredRules"
            :error-messages="fieldErrors.country_code"
            required
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            :label="$t('zip_code')"
            v-model="form.postal_code"
            dense
            outlined
            small
            required
            :rules="requiredRules"
            :error-messages="fieldErrors.postal_code"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            :label="$t('city')"
            v-model="form.city"
            dense
            outlined
            small
            required
            :rules="requiredRules"
            :error-messages="fieldErrors.city"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            :label="$t('region')"
            v-model="form.region"
            dense
            outlined
            small
            required
            :rules="requiredRules"
            :error-messages="fieldErrors.region"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <v-text-field
            :label="$t('first_line')"
            v-model="form.first_line"
            dense
            outlined
            small
            required
            :rules="requiredRules"
            :error-messages="fieldErrors.first_line"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            :label="$t('second_line')"
            v-model="form.second_line"
            dense
            outlined
            small
            required
            :rules="requiredRules"
            :error-messages="fieldErrors.second_line"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import Countries from '@/utils/countries'
import Utils from '@/utils/utils'

export default {
  name: 'BillingAddress',
  data: () => ({
    countrySearch: '',
    isFormValid: false,
    fieldErrors: {},
    form: {
      description: '',
      first_line: '',
      second_line: '',
      city: '',
      postal_code: '',
      region: '',
      country_code: ''
    }
  }),
  props: {
    address: {
      type: Object,
      required: true
    }
  },
  computed: {
    requiredRules () {
      return [v => !!v || this.$t('field_required')]
    },
    countries () {
      return Countries.map(({ code }) => {
        return { name: this.$t(`countries_${code}`), code }
      })
    }
  },
  watch: {
    address: {
      handler (newAddress) {
        if (newAddress.id) {
          this.form = { ...newAddress }
        }
        this.clearFieldErrors()
      },
      immediate: true,
      deep: true
    },
    'form.country_code' () {
      this.clearFieldError('country_code')
    },
    'form.postal_code' () {
      this.clearFieldError('postal_code')
    },
    'form.city' () {
      this.clearFieldError('city')
    },
    'form.region' () {
      this.clearFieldError('region')
    },
    'form.first_line' () {
      this.clearFieldError('first_line')
    },
    'form.second_line' () {
      this.clearFieldError('second_line')
    }
  },
  methods: {
    clearFieldErrors () {
      this.fieldErrors = {}
    },
    clearFieldError (fieldName) {
      if (this.fieldErrors[fieldName]) {
        this.$set(this.fieldErrors, fieldName, null)
      }
    },
    setFieldErrors (errors) {
      this.fieldErrors = { ...errors }
    },
    validate () {
      this.clearFieldErrors()
      return this.$refs.form ? this.$refs.form.validate() : this.isFormValid
    },
    async submit () {
      try {
        this.form.description = this.form.first_line
        return await this.$store.dispatch('updateAddress', { address: this.form })
      } catch (error) {
        if (error.response && error.response.status === 400 && error.response.data) {
          this.setFieldErrors(Utils.parseFieldErrors(error.response.data))
        }
        throw error
      }
    }
  },
  created () {
    this.form = { ...this.address }
  }
}
</script>

<style lang="sass" scoped>

.mb-3
  margin-bottom: 12px !important

</style>
